module.exports = __webpack_public_path__ + "static/media/emojis_01.ac19bf1f.svg";